import { Navigate } from 'react-router-dom';

/**
 * The companies used to be managed here, as one tab of the admin area. They
 * are now where a superadmin starts (pages/CompaniesHome), and this address
 * leads there so the admin area's own Companies tab keeps working.
 */
export function Companies() {
  return <Navigate to="/web/Companies" replace />;
}
